<template>
<div class="container" :class="{'section-loading': editLoading}">
  <main v-if="status == 'STATUS_RELEASE_TABLE' || status == 'STATUS_EDIT_UNIT'">
    <div class="tab-content">
      <div class="container-fluid">
        <table class="table table-basic mt-4 mb-4">
          <thead>
            <tr>
              <th width="300">發佈單位</th>
              <td v-if="editStatus">{{ editData.cedvnm }}</td>
              <td v-else>{{ UserInfo.divFullName }}</td>
            </tr>
            <tr>
              <th width="300">申請者</th>
              <td v-if="editStatus">{{ editData.last_editor }} {{ editData.dev_nm }}</td>
              <td v-else>{{ UserInfo.name }} {{ UserInfo.positionFullName }}</td>
            </tr>
            <tr>
              <th width="300">申請日期</th>
              <td v-if="!editStatus">{{ currentDate | dateFormat }}</td>
              <td v-else>{{ editData.apply_date | dateFormat }}</td>
            </tr>
          </thead>
        </table>

        <table class="table table-basic mt-4 mb-4">
          <thead>
            <tr> 
              <th width="300">條件名稱<br /><small style="color:#323A45">最多20個字元(10個中文字)</small></th>
              <td class="d-flex">
                <input type="text" :class="exceedLenght?'input-border-red':''" class="form-control w-50" v-model="filterName">
                <div v-if="exceedLenght" class="d-flex align-items-center text-danger ml-2">已超過最大字數</div>
              </td>
            </tr>
            <tr> 
              <th width="300">條件組合</th>
              <td class="list badgets">
                <span v-for="(item, index) in chText.split(';')" 
                style="min-height: 30px; height: auto; word-break: break-all;"
                :key="`reChText-${index}`" 
                class="item badget gray">{{ item }}</span>
              </td>
            </tr>
            <tr>
              <th width="300">發佈對象</th>
              <td v-if="editStatus">{{ editData.target }}</td>
              <td v-else>所有人</td>
            </tr>
            <tr>
              <th width="300">發佈日期</th>
                <td v-if="!editStatus" class="d-flex flex-column">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center">
                    <date-picker
                      v-model="release_date"
                      :format="dateFormatter"
                      :language="dateLang"
                      :first-day-of-week="1" 
                      ref = "picker"                     
                    />
                    <div class="d-flex justify-content-end" style="position: absolute; width:138px; height: 40px; font-size: 22px; color: #f58818; pointer-events: none;">
                        <img  
                          style ="position: relative; width: 18px; pointer-events: auto;"
                          src="../../../../../../public/assets/common/icon-close-red.svg"
                          v-show="release_date"
                          @click="$refs.picker.clearDate()"
                    />
                    </div>
                    <div
                        class="d-flex justify-content-end align-items-center"
                        style="padding:0 10px 0 50px; height: 40px; font-size: 24px; color: #f58818; outline: none;"
                        tabindex="-1"
                        @click="$refs.picker.showCalendar()"
                        @blur="$refs.picker.close()"  
                      >
                        <i class="icon-calendar" />
                    </div>
                  </div>  
                </div>
              </td>
              <td v-else>{{ editData.release_date | dateFormat }}</td>
            </tr>
            <tr>
              <th width="300">下架日期</th>
              <td class="d-flex flex-column">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center">
                    <date-picker
                      v-model="takeoff_date"
                      :format="dateFormatter"
                      :language="dateLang"
                      :first-day-of-week="1" 
                      ref = "picker2"                     
                    />
                    <div class="d-flex justify-content-end" style="position: absolute; width:138px; height: 40px; font-size: 22px; color: #f58818; pointer-events: none;">
                        <img  
                          style ="position: relative; width: 18px; pointer-events: auto;"
                          src="../../../../../../public/assets/common/icon-close-red.svg"
                          v-show="takeoff_date"
                          @click="$refs.picker2.clearDate()"
                    />
                    </div>
                    <div
                        class="d-flex justify-content-end align-items-center"
                        style="padding:0 10px 0 50px; height: 40px; font-size: 24px; color: #f58818; outline: none;"
                        tabindex="-1"
                        @click="$refs.picker2.showCalendar()"
                        @blur="$refs.picker2.close()"  
                      >
                        <i class="icon-calendar" />
                    </div>
                  </div>  
                </div>
              </td>
            </tr>
          </thead>
        </table>

        <div class="float-right">
          <button v-if="editStatus" class="btn btn-default" @click="formDown">直接下架</button>
          <button v-if="editStatus" class="btn btn-default" @click="returnSearchList">取消</button>
          <button v-else class="btn btn-default" @click="returnConditionList">取消</button>
          <button v-if="editStatus" class="btn btn-primary mt-0" @click="formEdit">儲存</button>
          <button v-else class="btn btn-primary mt-0" @click="formRelease" :disabled="!dateFull || exceedLenght">發佈</button>
        </div>
      </div>
    </div>
    <notice-modal
    :open="noticeModalOpen"
    :message="noticeMessage"
    :confirmText="noticeComfirmText"
    @close="panelClose('noticeModalOpen')"/>
  </main>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {commonMixin} from '@/mixins/common'
import DatePicker from '@/components/DatePicker/components/Datepicker'
import {en, zh} from '@/components/DatePicker/locale'
import { log } from 'util';
import NoticeModal from '@/desktop/components/NoticeModal';
import { inserUnitCondition, modifyCondition, conditionDown } from '@/service'


export default {
  name: 'ReleaseTable',
  mixins: [commonMixin],
  components: {DatePicker,NoticeModal},
  props: {
    title: {
      type: String,
      default: ''
    },
    chText: {
      type: String,
      default: ''
    },
    conditionData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    status: {
      type: String,
      default: ''
    },
    editData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    editStatus: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters([
      'UserInfo'
    ])
  },
  watch: {
    status(val) {  // 監聽 show 條件更新
      if(val == 'STATUS_RELEASE_TABLE' || val == 'STATUS_EDIT_UNIT'){
        this.initRelease()
      }
    },
    filterName: function() {  //不得超過20字元 10個中文字
      if(this.stringBytes(this.filterName) > 20) {
        this.exceedLenght = true
      }else{
        this.exceedLenght = false
      }
    },
    takeoff_date: function() {
      if(this.takeoff_date !== '' && this.release_date !== '') {
        this.dateFull = true
      }else{
        this.dateFull = false
      }
    },
    release_date: function() {
      if(this.takeoff_date !== '' && this.release_date !== '') {
        this.dateFull = true
      }else{
        this.dateFull = false
      }
    }
  },
  data () {  //data block layout
    return {
      currentRowID: null,
      currentDate: '',
      filterName: '',
      header: [],
      dataTree: [],
      editLoading: false,
      //Datepicker
      dateLang: zh,
      release_date:'',
      takeoff_date: '',
      dateFormatter: (date) => {
        const m = date.getMonth() + 1
        const d = date.getDate()
        return `${date.getFullYear() - 1911}/${(m < 10 ? '0' : '') + m}/${(d < 10 ? '0' : '') + d}`;
      },
      noticeModalOpen: false,
      noticeMessage: '',
      noticeComfirmText: '我知道了',
      isfull: '', //上架空間已滿,
      exceedLenght: false, //超過20字
      dateFull: false, //判斷date是否有填
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    initRelease () {  // 初始化
      this.currentDate = this.getCurrentDate()  // 取得當前日期
      this.filterName = this.title  // 條件組合的名稱 複製 title值
      if (this.editStatus) {
        this.takeoff_date = new Date(this.editData.takeoff_date)
        this.release_date = new Date(this.editData.release_date)
      }
      this.registerHanlink() // for 難字
    },
    stringBytes(c){ //計算字元長度 
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
            len++;
            s = s >> 8;
        }
      }
      return len;
    },
    fmDate (date) {  // 轉換 Date 物件為 'YYYY-MM-DD' string
      let nowDateY = date.getYear().toString().replace(/^./,'20')
      let nowDateM = (date.getMonth() + 1).toString().length == 1 ? `0${(date.getMonth() + 1).toString()}` : (date.getMonth() + 1).toString()
      let nowDateD = date.getDate().toString().length == 1 ? `0${date.getDate().toString()}` : date.getDate().toString()
      return `${nowDateY}-${nowDateM}-${nowDateD}`
    },
    returnSearchList () {  // 從編輯回到使用狀況查詢
      this.$emit('change-status','STATUS_SEARCH_LIST')
    },
    returnConditionList() {  // 發布頁導頁
      this.$router.push({path:`/manager/condition/tab/1`})
    },
    submitCheck () {  // submit 相關驗證
      if (this.filterName == '') {  // 條件名稱不得空白
        this.setToastMsg('條件名稱不得空白')
        return false
      }
      
      if (this.exceedLenght) {  // 條件名稱不得超過10個中文字
        this.setToastMsg('條件名稱不得超過10個中文字')
        return false
      }

      if (this.mixDateDiff(null, this.release_date) < 0) {
        this.setToastMsg('「發佈時間」需大於或等於編輯日')
        return false
      }

      if (this.mixDateDiff(this.release_date, this.takeoff_date) > 90) {
        this.setToastMsg('「發佈時間」距離「下架時間」最多3個月')
        return false
      }

      if (this.mixDateDiff(this.release_date, this.takeoff_date) < 0) {
        this.setToastMsg('「下架時間」需大於或等於「發佈時間」')
        return false
      }

      //  全部驗證 pass
      return true
    },
    editCheck () {  // 編輯 submit 相關驗證
      if (this.filterName == '') {  // 條件名稱不得空白
        this.setToastMsg('條件名稱不得空白')
        return false
      }

      if (this.exceedLenght) {  // 條件名稱不得超過10個中文字
        this.setToastMsg('條件名稱不得超過10個中文字')
        return false
      }

      if (this.mixDateDiff(this.release_date, this.takeoff_date) > 90) {
        this.setToastMsg('「發佈時間」距離「下架時間」最多3個月')
        return false
      }

      if (this.mixDateDiff(this.release_date, this.takeoff_date) < 0) {
        this.setToastMsg('「下架時間」需大於或等於「發佈時間」')
        return false
      }
      
      return true
    },
    formEdit () {  // 編輯 submit
      if(this.editCheck()){  // submit 相關驗證
        let end_date = this.fmDate(this.takeoff_date) // 下架日期 
        modifyCondition(this.$store.state.userInfo.id, end_date, this.filterName, this.editData.devfilter_serno, this.editData.release_date).then(result => {
          if(result && result.header.status == '200'){
            this.setToastMsg(result.header.message)
            this.$emit('change-status','STATUS_SEARCH_LIST')
          } else {
            this.setToastMsg(result.header.message)
          }
        })
      }
    },
    formRelease () {
      if(this.submitCheck()){  // submit 相關驗證
        let reprotData = {}
        reprotData.devno = this.$store.state.userInfo.divNo // 單位代號
        reprotData.agnt_name = this.$store.state.userInfo.name  // 申請人姓名
        reprotData.applydate = this.currentDate  // 申請日期
        reprotData.devfilter_name = this.filterName // 條件組合的名稱
        reprotData.opt_ch = this.chText // 	選項的中文
        reprotData.conditions = this.conditionData  // 	條件清單
        reprotData.upload_date = this.fmDate(this.release_date) // 發佈日期  
        reprotData.end_date = this.fmDate(this.takeoff_date) // 下架日期 
        reprotData.modifydate = this.currentDate  // 編輯日期
        inserUnitCondition(this.$store.state.userInfo.id, reprotData).then(result => {
          if(result && result.header.status == '200'){
            this.$toast.info({title: '已發佈一則條件設定'})
            this.$router.push({path:`/manager/condition/tab/1`})
          }else{
            this.setToastMsg(result.header.message)
          }
        })
      }
    },
    formDown () {
      this.editLoading = true
      let downData = {}
      downData.devfilter_serno = this.editData.devfilter_serno
      downData.end_date = this.editData.takeoff_date
      
      conditionDown(this.$store.state.userInfo.id, downData).then(result => {
        if(result && result.header.status == '200'){
            this.$toast.info({title: '下架成功'})
            this.returnSearchList()
            this.editLoading = false
          } else {
            if(result.header.message){
              this.$toast.info({title: result.header.message})
              this.editLoading = false
            } else{
              this.$toast.info({title: '下架失敗'})
              this.editLoading = false
            }
          }
      })
    }
  },
  mounted () {
    // this.initRelease() // 初始化
  }
}
</script>
<style scoped>
.list.badgets .badget.gray.item {
    padding: 0 22px;
    color: #323a45;
    background: #e0e1e3;
    border-radius: 8px;
    margin-right: 10px;
    margin-top: 10px;
    height: auto;
    text-align: -webkit-left;
}
</style>
